// Auto-refactored from translations.js on 2026-08-19
// Locale: sq

const sq = {
  wieMoeglich: { question: 'Si është e mundur kjo?', answer: 'Ne e kemi rimenduar zinxhirin e vlerës.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'Rruga STIG ROCK',
    fazit: 'Zinxhiri i shkurtuar i furnizimit eliminon zërat më të mëdhenj të kostos.',
    fazitBigPre: 'Kjo mundëson një zbritje deri në',
    fazitBigValue: '80%',
    steps: [ 'Miniera', 'Punishtja e prerjes', 'Certifikimi', 'Klienti fundor' ]
  },
  nav: { language: 'Gjuha', contact: 'Kontakt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Një mundësi unike',
    subtitle: 'Ndërtimi i pasurisë me orientim drejt së ardhmes.',
    description: 'STIG ROCK është një platformë ndërkombëtare që u ofron njerëzve qasje në diamante natyralë, ndërtim të qëndrueshëm pasurie dhe një komunitet unik.',
    scroll: 'Lëvizni poshtë për të zbuluar'
  },
  disclaimer: {
    overline: 'Njoftim ligjor',
    title: 'Disclaimer',
    paragraphs: [
      'Ky prezantim shërben vetëm për informim dhe nuk përbën këshillim financiar, investimi apo tatimor.',
      'STIG ROCK nuk është një produkt financiar, por i referohet Diamond natyralë si asete fizike.',
      'Nuk jepet asnjë garanci për ecurinë e vlerës, fitimet ose të ardhurat. Zhvillimet e kaluara nuk janë tregues për rezultatet e ardhshme.',
      'Të gjitha llogaritjet e paraqitura në lidhje me komisionet janë vetëm shembuj dhe gjithashtu nuk përbëjnë garanci.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'NDËRTUAR', 'MBI STRUKTURË' ],
    body: 'STIG Group është një korporatë ndërkombëtare, e ndërtuar mbi qartësinë, përgjegjësinë dhe vlerën afatgjatë. Çdo markë, çdo projekt dhe çdo Partneritet ndjek një standard të vetëm — pa rrugë të shkurtra, pa përjashtime.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'NDËRTUAR', 'MBI STRUKTURË' ],
        body: 'STIG Group është një korporatë ndërkombëtare, e ndërtuar mbi qartësinë, përgjegjësinë dhe vlerën afatgjatë. Çdo markë, çdo projekt dhe çdo Partneritet ndjek një standard të vetëm — pa rrugë të shkurtra, pa përjashtime.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'BOTA E', 'DIAMOND EKSKLUZIVË' ],
        body: 'STIG ROCK është një koncept modern i STIG Group, që ndërlidh Diamond e cilësisë së lartë të certifikuar nga GIA me struktura transparente dhe një përvojë ekskluzive për klientin. Plane zgjidhjeje të qarta, procese profesionale dhe orientim ndërkombëtar.'
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ 'TREGTIA', 'NDËRKOMBËTARE E DIAMOND' ],
        body: 'Stig International është pjesë e STIG Group dhe e specializuar në tregtinë ndërkombëtare me Diamond të certifikuar nga GIA. Fokus te cilësia, besimi dhe strukturat moderne të tregtisë me Partneritete globale.'
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'PËRGJEGJËSI', 'QË NGA MINIERA' ],
        body: 'ETHICAL MINES përfaqëson nxjerrjen e përgjegjshme, origjinën e gjurmueshme dhe Diamond pa konflikte. Nga miniera në treg — dokumentacion i plotë për transparencë, integritet dhe përgjegjësi afatgjatë përgjatë gjithë zinxhirit të furnizimit.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Diamante',
    stigDrawback: 'Ruajtës real i vlerës',
    overline: 'Mundësitë',
    title: 'Mundësi për ndërtimin e pasurisë',
    subtitle: 'Krahasimi i rrugëve tradicionale.',
    items: [
      {
        tag: 'Trading',
        name: 'Forex ose Kripto',
        drawback: 'shumë spekulativ, i paparashikueshëm, kompleks'
      },
      {
        tag: 'Aktien',
        name: 'Tregtimi në bursë',
        drawback: 'rrezik luhatjeje, kërkohen njohuri, kohë e konsiderueshme'
      },
      {
        tag: 'Krypto',
        name: 'Tregti',
        drawback: 'volatilitet, rrezik rregullator, dobësi sigurie'
      }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: 'Shansi i nënvlerësuar',
    body: 'Diamond numërohen prej vitesh ndër format më të qëndrueshme të investimit, por deri tani vetëm pak njerëz e kanë shfrytëzuar këtë potencial.',
    callout: 'Me STIG ROCK tonë, ne hapim për herë të parë aksesin për të gjithë në këto mundësi të jashtëzakonshme.'
  },
  wertentwicklung: {
    overline: 'Ecuria e vlerës 1995 — 2025',
    title: 'Një histori rreth vlerës.',
    usd: 'USD',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'Zhvillimi që nga 1995 — 2025'
  },
  hauptgruende: {
    overline: 'Arsyet kryesore',
    title: 'Gjashtë arsye për Diamond',
    lead: 'Diamond janë asete reale fizike që ekzistojnë pavarësisht nga valutat dhe sistemet financiare — dhe ruajnë vlerën e tyre prej shekujsh.',
    items: [
      {
        n: '01',
        title: 'Stabilitet vlere ndaj krizave',
        body: 'Garanci aktivesh fizike. Pavarur nga valutat dhe sistemet financiare.'
      },
      {
        n: '02',
        title: 'Mobiliteti suprem',
        body: "Të vegjël, të lehtë për t'u fshehur dhe për t'u transportuar."
      },
      {
        n: '03',
        title: 'Diversifikimi & rrallësia',
        body: 'Mungesë e ofertës dhe kufizim natyror.'
      },
      { n: '04', title: 'Rritje afatgjatë', body: '+185% që nga 1995.' },
      {
        n: '05',
        title: 'Transparenca & ekskluziviteti',
        body: '4 Cʼs si garanci: Carat, Color, Clarity, Cut.'
      },
      {
        n: '06',
        title: 'Rezerva e shtëpive mbretërore',
        body: 'Edhe shtëpitë mbretërore përdorin Diamond si rezervë pasurie.'
      }
    ]
  },
  markt: {
    overline: 'Vëllimi i tregut',
    title: '99 — 108 Mrd. USD',
    sub: 'Vëllimi i tregtisë në vitin 2025',
    forecast: 'Prognoza deri ~2032 / 2034: rreth 140 – 168 Mrd. USD me një rritje të moderuar (~4 – 5 % p.a.).',
    source: 'Burimi: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Inovacion',
    title: 'Një inovacion. Për herë të parë në botë.',
    body: 'STIG ROCK është platforma e parë në botë që u mundëson njerëzve të gjenerojnë të ardhura pasive në tregun e diamanteve, përveç rritjes së vlerës.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Nr. Regjistrimi DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Rreth kompanisë',
    titleLines: [ 'STRUKTURË', 'NDËRKOMBËTARE', 'VIZION I QARTË' ],
    body: 'STIG ROCK u themelua për ta bërë tregun e diamanteve më transparent, më modern dhe më të orientuar drejt klientit — me fokus te besimi, siguria dhe struktura afatgjatë.'
  },
  sicherheit: {
    overline: 'Cilësia & Siguria',
    title: 'Gemological Institute of America',
    body: 'Ekspertizë e certifikuar për Diamond tuaj. GIA vlerëson çdo gur me precizionin më të lartë dhe përvojë shumëvjeçare — raporte vlerësimi të besueshme për kompaninë tonë dhe klientët tanë.',
    transparency: 'Çdo Diamond plotëson standardet më të larta të cilësisë dhe kontrollohet e certifikohet nga organizata të njohura. Çdo gur është unik dhe merr një certifikatë individuale.'
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Një inovacion unik produkti',
    sub: 'Gjashtë Solution Pläne të shkallëzuara — nga $1K deri në $100K+, secili me zbritje në rritje për muaj dhe gjatë gjithë kohëzgjatjes.',
    recommended: 'I pëlqyer',
    oneYear: '1 vit',
    rowLabels: {
      delivery: 'Koha e dorëzimit',
      price: 'Çmimi i produktit',
      carat: 'Karat',
      monthly: 'Zbritje (muaj)',
      totalDiscount: 'Zbritje (Total)',
      duration: 'Kohëzgjatja'
    },
    headers: {
      plan: 'Plan',
      from: 'Nga',
      carat: 'Karat',
      monthly: 'Zbritje / Muaj',
      total: 'Zbritje Total',
      duration: 'Kohëzgjatja'
    },
    duration: '1 vit',
    footnote: 'Të gjitha çmimet janë pa garanci dhe varen nga cilësia, kërkesa dhe ecuria aktuale e tregut. Planet Solution janë të mundshme edhe për 2 vite.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + Paketa VIP',
    title: 'Më shumë përfitime me VIP-Paket',
    sub: 'Kombinoje Solution Plan tënde me një VIP-Paket dhe përfito nga avantazhe shtesë çmimi deri në 3%. Kështu e rrit zbritjen tënde totale dhe siguron kushte edhe më tërheqëse.',
    rowLabels: {
      delivery: 'Koha e dorëzimit',
      price: 'Çmimi i produktit',
      carat: 'Karat',
      monthly: 'Zbritje (muaj)',
      totalDiscount: 'Zbritje (Total)',
      vip1: 'Paketa VIP 1 (+1%)',
      vip2: 'Paketa VIP 2 (+2%)',
      vip3: 'Paketa VIP 3 (+3%)'
    },
    footnote: 'Të gjitha çmimet janë pa garanci dhe varen nga cilësia, kërkesa dhe ecuria aktuale e tregut.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Më shumë përfitime me VIP-Paket',
    sub: 'Kombinoje Solution Plan tënde me një VIP-Paket dhe përfito nga avantazhe shtesë çmimi deri në 3%. Kështu e rrit zbritjen tënde totale dhe siguron kushte edhe më tërheqëse.',
    options: [
      {
        key: 'deliver',
        title: 'Më shumë përfitime me VIP-Paket',
        body: 'Diamond (Karat) për çmimin e DS-Plan tuaj*'
      },
      {
        key: 'sellToUs',
        title: 'Na i shitni ne',
        body: "Ju mund t'i rishitni Diamond tuaj te ne me çmimin e blerjes që keni paguar."
      },
      {
        key: 'sellThirdParty',
        title: 'Shitja te palët e treta',
        body: "Ju mund t'i rishitni Diamond tuaj te palët e treta."
      }
    ],
    footnote: '*DS-Plan do të thotë Solution Plan.'
  },
  tradWeg: {
    overline: 'Tregtia tradicionale',
    title: 'Rruga tradicionale',
    sub: 'Para se një Diamond të arrijë te klienti fundor, përmes tregtisë së ndërmjetme, me shumicë dhe pakicë krijohen marzhe të konsiderueshme tregtare në krahasim me çmimin e Diamond bruto nga miniera.',
    steps: [
      { title: 'Miniera', subtitle: 'Diamond bruto' },
      { title: 'Ndërmjetësit', subtitle: 'Blerja e Diamond bruto' },
      { title: 'Prerja dhe Lustrimi', subtitle: 'Prerja në Diamond bizhuterie' },
      { title: 'Certifikimi', subtitle: 'nga institute të njohura si GIA' },
      { title: 'Bursa e Diamond', subtitle: 'Shitja te tregtia me shumicë' },
      { title: 'Tregtia me shumicë', subtitle: 'Shitja te tregtia me pakicë' },
      { title: 'Tregtia me pakicë', subtitle: 'p.sh. argjendarët' },
      { title: 'Klientët fundorë', subtitle: 'Blerja e Diamond' }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Paketat VIP',
    sub: 'Të vlefshme për 12 muaj për të gjitha planet Solution të nënshkruara prej jush. Sipas Paketës VIP: +1% deri në +3% zbritje shtesë',
    cardKicker: 'shtesë – mbi të gjitha',
    cardKicker2: 'Planet Solution',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'Zbritjet kthehen në kursime',
      body: 'Kursim mujor në vend të barrës mujore. Nga zbritjet krijohen kursime — dhe këto paguajnë pikërisht ato gjëra për të cilat përndryshe paguani çdo muaj nga xhepi juaj.',
      line1Label: 'DS-Plan nga',
      line1Value: '$5.000',
      line2Label: 'zbritje muj.',
      line2Value: '3%',
      line3Label: 'Paketa VIP 3',
      line3Value: '+3%',
      resultLabel: 'kursime mujore',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Si është e mundur?',
    title: 'Ne kemi rimenduar zinxhirin e vlerës.',
    traditionalTitle: 'Rruga tradicionale',
    traditionalSteps: [
      'Miniera — Diamond bruto',
      'Ndërmjetësit — Blerja',
      'Prerja dhe Lustrimi — Prerja',
      'Certifikimi (GIA)',
      'Bursa e Diamond — Tregtia me shumicë',
      'Tregtia me shumicë → Tregtia me pakicë',
      'Argjendarët → Klienti fundor'
    ],
    traditionalNote: 'Para se një Diamond të arrijë te klienti fundor, krijohen marzhe të konsiderueshme tregtare përmes ndërmjetësve, tregtisë me shumicë dhe pakicë.',
    stigTitle: 'Rruga e STIG ROCK',
    stigSteps: [
      'Blerje direkte — Diamond bruto nga miniera',
      'Prerja & Certifikimi nga Partnerët tanë',
      'Shitja te klientët fundorë & klientët B2B',
      'Deri në 4 cikle tregtare në vit'
    ],
    stigNote: 'Ne e thyejmë ciklin dhe ua kalojmë marzhet tregtare si kreditime zbritjeje klientëve tanë — deri në 4 cikle tregtare gjatë kohëzgjatjes së DS-Plan.'
  },
  optionen: {
    overline: 'Mundësitë tuaja',
    title: 'Pas përfundimit të DS-Plan tuaj',
    items: [
      { title: 'Dërgimi në adresë', body: 'Diamond (Karat) për çmimin e DS-Plan tuaj.' },
      { title: 'Na i shitni ne', body: 'Rishitje me çmimin e blerjes që keni paguar.' },
      { title: 'Shitja te palët e treta', body: 'Shitja e Diamond në tregun e lirë.' }
    ]
  },
  einfacherWeg: {
    overline: 'Planet Solution — një inovacion unik produkti',
    title: 'Rruga e thjeshtë',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Regjistrimi',
        body: 'Kontaktoni personin që ju rekomandoi dhe krijoni një llogari falas!'
      },
      {
        n: '02',
        icon: 'cart',
        title: 'Blerja e një produkti',
        body: 'Duke filluar që nga $ 250,-'
      },
      {
        n: '03',
        icon: 'discount',
        title: 'Përfitimi i zbritjeve',
        body: 'Merrni kreditime mujore të zbritjes.'
      }
    ]
  },
  business: {
    overline: 'Llojet e bonuseve',
    title: 'Rruga më e thjeshtë dhe më e drejtë.',
    sub: 'Pesë lloje bonusesh — për ndërtimin e suksesshëm të biznesit tuaj.',
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Deri në nivelin 3, nga niveli i karrierës Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Nga Sapphire — në thellësi të pafundme.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Mbi Infinity Bonus – deri në nivelin 5 · PA kualifikim.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 poole të qarkullimit botëror.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: 'Bonus unik në Diamond (Karat).'
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: 'Ky bonus ju paguhet për çdo DS-Plan të ri të nënshkruar deri në nivelin e 3-të. Me kualifikime shumë të ulëta, ju hapni nivelet individuale.',
    total: 'Deri në 18% Unilevel Bonus',
    levels: [
      {
        level: 'Niveli 1',
        value: '10%',
        qual: 'që nga fillimi',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Niveli 2',
        value: '5%',
        qual: 'nga niveli i karrierës Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Niveli 3',
        value: '3%',
        qual: 'nga niveli i karrierës Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: 'Nga niveli i karrierës Sapphire ju kualifikoheni për planin tonë Infinity Bonus. Ju merrni 3% bonus. Me çdo nivel të ri karriere shtohen përqindje të tjera. Nëse një Partner në ekipin tuaj është gjithashtu i kualifikuar, ju merrni diferencën nga rangu në rang.',
    exampleTitle: 'Shembull',
    exampleRows: [
      { label: 'Ju jeni Blue Diamond', value: '12%' },
      { label: 'Partneri juaj është Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'Infinity Bonus juaj', value: '9%' },
    totalNote: 'Gjithsej deri në 24% Infinity Bonus mbi të gjitha planet Solution të nënshkruara në ekipin tuaj — në thellësi të pafundme.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: 'Me këtë bonus ju përfitoni nga suksesi i ekipit tuaj. Ju merrni një Matching Bonus prej 5% mbi Infinity Bonus të Partnerëve tuaj — dhe kjo deri në nivelin e 5-të të ekipit tuaj.',
    note: 'Mbi të gjitha pagesat e Infinity Bonus në ekipin tuaj – deri në nivelin e 5-të. Që nga fillimi – PA kualifikim.',
    levels: [
      { level: 'Niveli 1', value: '5%' },
      { level: 'Niveli 2', value: '5%' },
      { level: 'Niveli 3', value: '5%' },
      { level: 'Niveli 4', value: '5%' },
      { level: 'Niveli 5', value: '5%' }
    ],
    totalPrefix: 'Gjithsej deri në',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: '3% e qarkullimit botëror shkon në pjesë të barabarta në 3 poole të ndryshme. Duke arritur nivele të caktuara karriere, ju kualifikoheni për secilin pool individual.',
    forever: 'Arritur një herë – pjesëmarrës për GJITHMONË!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'nga Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'nga Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'nga Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Gjithsej',
    totalValue: '3%',
    totalSuffix: 'e qarkullimit botëror'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: 'Nga niveli i karrierës Diamond ju merrni një Rang Bonus. Ky paguhet në Diamond (Karat). Bëhet fjalë për një bonus që jepet vetëm një herë.',
    highlight: 'Diamond (Karat) me vlerë totale prej',
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Nivelet e karrierës',
    title: 'Nivelet e karrierës',
    sub: 'Për arritjen e niveleve përkatëse të karrierës llogaritet qarkullimi historik i përgjithshëm (HG). Ky duhet të jetë i shpërndarë në disa ekipe që nga niveli Sapphire. Për të arritur Ruby ose më lart, ju nevojiten të paktën dy Partnerë direktë me një Solution Plan.',
    forever: 'Arritur një herë – konfirmuar për GJITHMONË!',
    footnote: 'HV = Historisches Volumen.',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 Partnerë dir.', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Filloni suksesin me ne',
    title: 'Koha e duhur është pikërisht tani.',
    body: 'Ky model biznesi vendos standarde të reja dhe bashkon të gjithë faktorët e suksesit për një biznes të qëndrueshëm dhe të suksesshëm afatgjatë. Regjistrohuni sot, zgjidhni DS-Plan tuaj dhe shfrytëzoni këtë mundësi unike biznesi.',
    hint: 'Flisni me personin që ju ftoi në këtë prezantim — ai ka një link regjistrimi për ju.',
    formName: 'Emri',
    formEmail: 'E-Mail',
    formPhone: 'Telefoni',
    formSubmit: 'Na kontaktoni',
    success: "Ju faleminderit — ne do t'ju kontaktojmë në mënyrë diskrete dhe personale.",
    callCta: 'Telefononi',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Njoftim ligjor & Disclaimer',
    disclaimer: 'Ky prezantim shërben vetëm për informim dhe nuk përbën këshillim financiar, investimi apo tatimor. STIG ROCK nuk është një produkt financiar, por i referohet Diamond natyralë si asete fizike. Nuk jepet asnjë garanci për ecurinë e vlerës, fitimet ose të ardhurat. Zhvillimet e kaluara nuk janë tregues për rezultatet e ardhshme. Të gjitha llogaritjet e paraqitura në lidhje me komisionet janë vetëm shembuj dhe gjithashtu nuk përbëjnë garanci. Rezervohet e drejta për ndryshime të përmbajtjes — përkthim i lirë (jo përkthim zyrtar).',
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Të gjitha të drejtat e rezervuara.',
    version: 'Versioni: DS-12-2025 V3'
  },
  misc: { next: 'Seksioni tjetër' }
};

export default sq;
